import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import ProductReportLayer from "../components/ProductReportLayer";
import usePermission from "../hook/usePermission";
import AccessDeniedLayer from "../components/AccessDeniedLayer";

const ProductReportPage = () => {
    const hasPermission = usePermission("productReport", "view"); // Using specific product report permission
    return (
        <>
            <MasterLayout>
                <Breadcrumb title="Product Sales Report" header="Product Sales Report" />
                {hasPermission ? <ProductReportLayer /> : <AccessDeniedLayer />}
            </MasterLayout>
        </>
    );
};

export default ProductReportPage;
